const DsmSensitivityUXUI: { [key: string]: string } = {
  "0": "Low_2",
  "1": "Medium_2",
  "2": "High_3",
};

export default DsmSensitivityUXUI;
